import { Group, Paper, ScrollArea, Stack, Text } from '@mantine/core'

import type { MetadataRow } from './metadata'

const MetadataPanel = ({ rows }: { rows: MetadataRow[] }) => (
  <Paper withBorder radius="md" p="lg" style={{ minWidth: 0, minHeight: 0, overflow: 'hidden' }}>
    <ScrollArea h="100%" offsetScrollbars>
      <Stack gap="sm">
        {rows.map(row => (
          <Group key={row.key} gap="md" wrap="nowrap" align="flex-start">
            <Text size="sm" c="dimmed" w={120} style={{ flex: 'none' }}>
              {row.key}
            </Text>
            <Text size="sm" ff={row.mono ? 'monospace' : undefined} style={{ wordBreak: 'break-word' }}>
              {row.value}
            </Text>
          </Group>
        ))}
      </Stack>
    </ScrollArea>
  </Paper>
)

export default MetadataPanel
